import axios from 'axios';
import CONSTS from '../../config/constants';
const { API_AUTH } = CONSTS.SERVICES;

export const userGet = () => axios.get('/b/private/account/profile', {
  headers: {
    service: API_AUTH,
  },
});

export const updatePassword = (params) => axios.post('/b/private/account/password', {
  ...params
}, {
  headers: {
    service: API_AUTH,
  },
});